import { useContext, useState } from 'react';
import { useToast } from '@chakra-ui/react';
import CustomToast from '../common/CustomToast';
import { HttpContext } from '../context/HttpContext';
import { MeContext } from '../context/MeContext';
import { useReportAndToastApiError } from './useReportAndToastApiError';

export const useEmailBatchReport = () => {
  const { authAxios } = useContext(HttpContext);
  const meCtx = useContext(MeContext);
  const toast = useToast();
  const reportAndToastApiError = useReportAndToastApiError();
  const [emailingBatchId, setEmailingBatchId] = useState<
    string | number | null
  >(null);

  const emailReport = async (batchId: string | number) => {
    const email = meCtx.state.account?.email;
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    setEmailingBatchId(batchId);
    try {
      await authAxios.get(
        `api/v1/batches/${batchId}?export=true&timezone=${encodeURIComponent(
          timezone
        )}&email=${encodeURIComponent(email)}`
      );
      toast({
        render: (props) => (
          <CustomToast
            status="info"
            title="Please check your email"
            description={`A download link has been sent to ${email}. It may take a few minutes to arrive.`}
            onClose={props.onClose}
          />
        ),
      });
    } catch (error) {
      reportAndToastApiError(error);
    } finally {
      setEmailingBatchId(null);
    }
  };

  return { emailReport, emailingBatchId };
};
